import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=68d0b0b2&scoped=true&"
import script from "./RoleCard.vue?vue&type=script&lang=js&"
export * from "./RoleCard.vue?vue&type=script&lang=js&"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=68d0b0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0b0b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions,VCardText})


/* vuetify-loader */
import installDirectives from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
